import { TimePicker as AntdTimePicker, ConfigProvider } from 'antd'
import dayjs from 'dayjs'
import { Form } from 'react-bootstrap'

export default function TimePicker(props) {

    const { label_name, placeholder, name, value, onChange, onBlur, error, mandatory, reference, tabIndex } = props

    return (
        <>
            <Form.Group className="mb-2" controlId={name}>
                <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{`${label_name}${mandatory ? '*' : ''}`}</Form.Label>
                <ConfigProvider
                    theme={{
                        components: {
                            DatePicker: {
                                activeShadow: '0 0 0 0.16rem rgba(0, 105, 114, 0.2)',
                                hoverBg: '#F6F3F5',
                                activeBg: '#F6F3F5',
                                zIndexPopup: '99999'
                            },
                        },
                        token: {
                            colorBorder: '#ccc',
                            fontFamily: 'Inter'
                        },
                    }}
                >
                    <AntdTimePicker
                        ref={reference}
                        key={value}
                        className='form-control form_input'
                        placeholder={placeholder}
                        format={"HH:mm"}
                        name={name}
                        defaultValue={value ? dayjs(value, 'HH:mm') : ''}
                        onChange={onChange}
                        onBlur={onBlur}
                        tabIndex={tabIndex}
                        needConfirm={false}
                    />
                </ConfigProvider>
                {error}
            </Form.Group>
        </>
    )
}
